import StarRating from '../common/StarRating';
import { useReviews } from '../../context/ReviewsContext';

/** "★★★★☆ 4.3 (12)" from approved ratings; nothing until the store shows ratings and the product has one. */
const ProductRating = ({ productId, size = 'sm', className = '' }) => {
  const { ratingFor } = useReviews();
  const r = ratingFor(productId);
  if (!r) return null;
  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="product-rating">
      <StarRating rating={r.average} count={null} size={size} />
      <span className="text-[11px] text-ink-muted">{r.average.toFixed(1)} ({r.count.toLocaleString('en-IN')})</span>
    </div>
  );
};

export default ProductRating;
